import {useState, useCallback} from 'react';
import globalDomains from '@/utils/global-domains';
import {ILLEGAL_FILE_HWP, ILLEGAL_FILE_DOCX} from '@/constants/help/illegal';

const FILE_DOWNLOAD_URL = `${globalDomains.RES_AFREECATV}/new_help/docs/`;

export type FileDownloadType = 'hwp' | 'docx';

const useFileDownload = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadFile = useCallback(
    async (type: FileDownloadType) => {
      const link = document.createElement('a');
      if (isDownloading) {
        return;
      }
      setIsDownloading(true);

      try {
        const originalFileName =
          type === 'hwp' ? ILLEGAL_FILE_HWP : ILLEGAL_FILE_DOCX;
        const timestamp = Date.now();
        link.href = `${FILE_DOWNLOAD_URL}${originalFileName}?t=${timestamp}`;
        link.download = decodeURIComponent(originalFileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('파일 다운로드 중 오류가 발생했습니다:', error);
      } finally {
        setIsDownloading(false);
        if (document.body.contains(link)) {
          document.body.removeChild(link);
        }
      }
    },
    [isDownloading],
  );

  return {downloadFile};
};

export default useFileDownload;
